import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Box, Slide, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material";

import constants from "../../../assets/constants";

const TopicImages = props => {
  const { images, interval, theme, isPlaying } = props;
  const imageTimerRef = useRef(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [slideIn, setSlideIn] = useState(true);
  const [slideDirection, setSlideDirection] = useState("left");

  const largeScreen = useMediaQuery(theme => theme.breakpoints.up("lg"));

  const goNext = imageCount => {
    setSlideDirection("right");
    setSlideIn(false);
    let timer = setTimeout(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % imageCount);
      setSlideDirection("left");
      setSlideIn(true);
      clearTimeout(timer);
    }, 500);
  };

  useEffect(() => {
    if (isPlaying) {
      imageTimerRef.current = setInterval(() => {
        goNext(images.length);
      }, interval);
    } else {
      return () => clearInterval(imageTimerRef.current);
    }
    return () => clearInterval(imageTimerRef.current);
  }, [images, interval, isPlaying]);

  useEffect(() => {
    if (currentImageIndex === images.length - 1 && isPlaying) {
      setTimeout(() => {
        clearTimeout();
      }, interval - 500);
    }
  }, [images, interval, currentImageIndex, isPlaying]);

  return (
    <Box
      sx={{
        margin: theme.spacing(2),
        overflow: "hidden",
      }}
    >
      {images.map((src, index) => (
        <Slide
          direction={slideDirection}
          in={slideIn && index === currentImageIndex}
          timeout={500}
          mountOnEnter
          unmountOnExit
          key={index}
          sx={{ height: "100%", width: "100%" }}
        >
          <img
            component="img"
            src={src}
            alt={`Slide ${index}`}
            height={largeScreen ? "100%" : "auto"}
            width={largeScreen ? "auto" : "100%"}
            sx={{ objectFit: "contain" }}
          />
        </Slide>
      ))}
    </Box>
  );
};

const Topic = props => {
  const { topic, interval, theme, isPlaying } = props;

  const [slideDirection] = useState("left");

  return (
    <Box sx={{ margin: theme.spacing(2) }}>
      <Slide direction={slideDirection} in={topic} timeout={500} mountOnEnter unmountOnExit>
        <Box key={topic.id}>
          <TopicImages
            theme={theme}
            images={topic.imageLinks}
            interval={interval}
            isPlaying={isPlaying}
          />
        </Box>
      </Slide>
    </Box>
  );
};

const NsightInformation = props => {
  const topics = constants.nsightUserToDosLearningTopics;
  const interval = 5000;
  const theme = useTheme();
  const isPlaying = true;
  const topicIndex = topics && topics.length > 0 ? 0 : -1;

  return (
    <>
      {topics && topicIndex >= 0 && (
        <Topic topic={topics[topicIndex]} theme={theme} interval={interval} isPlaying={isPlaying} />
      )}
    </>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NsightInformation));
